import type {QueryClient} from '@tanstack/react-query'

import {rentalAssetKeys} from 'src/assets/rental-assets/query-keys'
import {equipmentCheckKeys} from 'src/equipment-checks/query-keys'
import {jobKeys} from 'src/jobs/query-keys'
import {projectKeys} from 'src/projects/query-keys'
import {rentalBillingKeys} from 'src/rental-billing/query-keys'
import {activeRentalKeys} from 'src/rentals/query-keys'
import {workKeys} from 'src/work/query-keys'

import {projectDeployedEquipmentKeys} from './query-keys'

/**
 * Invalidate equipment location, rental, billing, and exception queries for a project.
 * A null projectId invalidates every project detail.
 */
export function invalidateEquipmentMoves(queryClient: QueryClient, projectId: string | null) {
    return Promise.all([
        queryClient.invalidateQueries({
            queryKey: projectId
                ? projectDeployedEquipmentKeys.detail(projectId)
                : projectDeployedEquipmentKeys.all,
        }),
        queryClient.invalidateQueries({queryKey: workKeys.all}),
        queryClient.invalidateQueries({queryKey: activeRentalKeys.all}),
        queryClient.invalidateQueries({queryKey: rentalBillingKeys.all}),
        queryClient.invalidateQueries({queryKey: jobKeys.all}),
        queryClient.invalidateQueries({
            queryKey: projectId ? projectKeys.detail(projectId) : projectKeys.details(),
        }),
        queryClient.invalidateQueries({queryKey: projectKeys.lists()}),
        queryClient.invalidateQueries({queryKey: equipmentCheckKeys.all()}),
        queryClient.invalidateQueries({queryKey: rentalAssetKeys.stockSummaries()}),
        queryClient.invalidateQueries({
            predicate: ({queryKey}) =>
                (queryKey[0] === 'rental-assets' && queryKey[2] === 'assignments') ||
                (queryKey[0] === 'rental-asset-types' && queryKey[2] === 'stock-summary'),
        }),
    ])
}
